import * as React from "react";
import styles from "./Exhibition.module.css";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Typography,
  ImageList,
  ImageListItem,
  Backdrop,
} from "@mui/material";
import Header from "../../Components/Layout/Header";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import Parse from "../../API/ParseServer";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { Slide } from "react-slideshow-image";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Album from "../../Components/Album/Album";
import Footer from "../../Components/Layout/Footer";

const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};
const Event = () => {
  const params = useParams();
  const [event, setEvent] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [images, setImages] = useState<any[]>();
  const [selectedImage, setSelectedImage] = useState(0);
  const [isLiked, setIsLiked] = useState();
  const [album, setAlbum] = useState<any>();
  const [albumArray, setAlbumArray] = useState<number[]>([]);

  useEffect(() => {
    const fetchEvent = async () => {
      const query = new Parse.Query("Artfair_Festival");
      query.equalTo("objectId", params.eventId);
      const user = Parse.User.current();

      try {
        const results = await query.find();
        if (results.length > 0) {
          setEvent(results[0]);
          const imagesQuery = new Parse.Query("Artfair_FestivalImage");
          imagesQuery.equalTo("objectId", results[0].get("images").id);
          try {
            const imageResults = await imagesQuery.find();
            if (imageResults.length > 0) {
              // setArtworkId(results[0].id);
              let imageList = [];
              // imageList.push(thumbnail);
              for (
                let index = 1;
                index <= results[0].get("imageCount");
                index++
              ) {
                imageList.push(imageResults[0].get(`file${index}`).url());
              }
              setImages(imageList);
            } else {
              throw new Error("Artwork Images not found.");
            }
          } catch (err: any) {
            setError(err.message);
          } finally {
            setLoading(false);
          }

          const albumQuery = new Parse.Query("Artfair_FestivalAlbum");
          albumQuery.equalTo("objectId", results[0].get("album").id);

          try {
            const albumResult = await albumQuery.find();
            if (albumResult[0]) {
              setAlbum(albumResult[0]);
              for (let i = 1; i <= albumResult[0].get("counter"); i++) {
                setAlbumArray((cur: number[]) => {
                  if (!cur.find((num: any) => num === i)) return [...cur, i];
                  else return cur;
                });
              }
            }

            // console.log(results);
          } catch (err: any) {
            // setErrorMessage(err.message);
          } finally {
            setLoading(false);
          }
          if (user)
            setIsLiked(
              results[0].get("likeUsers")
                ? results[0].get("likeUsers").includes(user.id)
                : false
            );
        } else {
          throw new Error("Event not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [params.eventId]);

  const imageClickHandler = (event: any) => {
    console.log(event.target.id);
    setSelectedImage(Number(event.target.id));
  };
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };
  const [likeError, setLikeError] = useState("");

  const likeHandler = async () => {
    const user = Parse.User.current();
    if (user) {
      let response: any;
      try {
        response = await Parse.Cloud.run("toggleEventLike", {
          eventId: params.eventId,
          userId: user.id,
        });
      } catch (error: any) {
        console.error(error.message);
        alert(error.message);
      } finally {
        if (response) setIsLiked(response.isLiked);
      }
    } else {
      setLikeError("You need to login first!");
      setTimeout(() => {
        setLikeError("");
      }, 1000);
    }
  };
  const copyHandler = () => {
    window.navigator.clipboard.writeText(document.URL);
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: "30rem",
          // backgroundColor: "gray",
          position: "relative",
          // zIndex: "-1",
          // top: "4rem",
        }}
      >
        {" "}
        {event && event.get("banner") && (
          <img
            src={event.get("banner").url()}
            alt="banner"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -5,
              height: "30rem",
              width: "100%",
            }}
          />
        )}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            height: "30rem",
            width: "100%",
            backgroundColor: "black",
            opacity: 0.5,
          }}
        ></Box>
        {event && (
          <Container>
            {" "}
            <Box
              sx={{
                color: "white",
                height: "34rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant="h4" component="h2" sx={{ my: 5 }}>
                {event.get("title")}
              </Typography>
              <Typography variant="h5" component="h2">
                {event.get("startDate").toDateString()} -{" "}
                {event.get("endDate").toDateString()}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ marginTop: 3, fontStyle: "italic" }}
              >
                {event.get("description")}
              </Typography>
              <Box sx={{ marginTop: 1, position: "relative" }}>
                {isLiked ? (
                  <IconButton
                    aria-label="remove to favorites"
                    onClick={likeHandler}
                  >
                    <FavoriteIcon sx={{ color: "#8d462b", fontSize: "35px" }} />
                  </IconButton>
                ) : (
                  <IconButton
                    aria-label="add to favorites"
                    onClick={likeHandler}
                  >
                    <FavoriteBorderOutlinedIcon
                      sx={{ color: "white", fontSize: "35px" }}
                    />
                  </IconButton>
                )}
                {likeError && (
                  <Typography
                    variant="caption"
                    sx={{ position: "absolute", bottom: -13, left: -36 }}
                  >
                    {likeError}
                  </Typography>
                )}
                <IconButton onClick={copyHandler}>
                  <ShareOutlinedIcon
                    sx={{ color: "white", fontSize: "35px" }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Container>
        )}
      </Box>
      {event && (
        <Container>
          <Box
            sx={{
              mt: 10,
              borderBottom: "2px solid #dad9da",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Event Information
            </Typography>
          </Box>
          <Grid container my={3} sx={{ justifyContent: "space-between" }}>
            <Grid item xs={12} md={5}>
              {event.get("information") &&
                event.get("information").map((item: string) => (
                  <Typography variant="body1">
                    {item}
                    <br />
                  </Typography>
                ))}
            </Grid>
            {images && (
              <Grid item xs={12} md={6} sx={{}}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    height: "25rem",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={images[selectedImage]}
                    alt=""
                    style={{
                      height: "90%",
                      objectFit: "contain",
                      maxWidth: "100%",
                      cursor: "pointer",
                    }}
                    id={String(selectedImage)}
                    onClick={handleOpen}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    overflow: "scroll",
                    width: "100%",
                    display: "flex",
                    gap: 2,
                  }}
                >
                  {images.map((image: string, index) => (
                    <img
                      src={image}
                      alt=""
                      className={
                        selectedImage === index
                          ? styles["selected-pic"]
                          : styles["unselected-pic"]
                      }
                      id={String(index)}
                      onClick={imageClickHandler}
                    />
                  ))}
                </Grid>
                <Backdrop
                  sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                  })}
                  open={modal === "" ? false : true}
                  // onClick={handleClose}
                >
                  <Box
                    sx={{
                      backgroundColor: "white",
                      width: { xs: "95vw", lg: "50rem" },
                      // height: { xs: "30rem", lg: "auto" },
                      display: "flex",
                      justifyContent: "space-between",
                      // alignItems: "center",
                      color: "black",
                      py: { md: 5, xs: 2 },
                      px: { md: 8, xs: 4 },
                      position: "relative",
                      flexDirection: "column",
                    }}
                  >
                    <button
                      style={{
                        position: "absolute",
                        right: "3rem",
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                        top: "2rem",
                      }}
                      onClick={handleClose}
                    >
                      <ClearIcon />
                    </button>

                    <Typography component="h2" variant="h4">
                      Album
                    </Typography>
                    {/* <Typography>
                      Explore a handpicked selection of our previously framed
                      works.
                    </Typography> */}
                    <br />
                    {images && modal && (
                      <Slide
                        slidesToScroll={1}
                        // indicators={indicators}
                        {...properties}
                        // duration={}
                        autoplay={false}
                        transitionDuration={800}
                        defaultIndex={Number(modal)}
                      >
                        {images.map((img: any, index) => (
                          <Box
                            sx={{
                              backgroundColor: "white",
                              padding: "1rem",
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                              height: "100%",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={img}
                              alt=""
                              style={{
                                width: "100%",
                                // aspectRatio: 1,
                                marginBottom: "1rem",
                                // maxWidth: "20rem",
                                cursor: "pointer",
                              }}
                              // id={String(ind)}
                              // onClick={handleOpen}
                            />
                          </Box>
                        ))}
                      </Slide>
                    )}
                  </Box>
                </Backdrop>
              </Grid>
            )}
          </Grid>
          <Box
            sx={{
              borderBottom: "2px solid #dad9da",
              width: "100%",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Participating Artists
            </Typography>
          </Box>
          <Grid container>
            {event.get("artists").map((artist: any) => (
              <Grid item xs={6} md={3} sx={{ mb: 2 }}>
                <Typography variant="subtitle1">{artist}</Typography>
              </Grid>
            ))}
          </Grid>
          {album && (
            <React.Fragment>
              <Box
                sx={{
                  borderBottom: "2px solid #dad9da",
                  width: "100%",
                  my: "1rem",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    display: "inline",
                    boxShadow: "0 2px #0a0a0a",
                    paddingBottom: "4px",
                  }}
                >
                  Photo Album
                </Typography>
              </Box>
              <Box sx={{ width: "100%" }}>
                {<Album album={album} albumArray={albumArray} />}
              </Box>
            </React.Fragment>
          )}
        </Container>
      )}
    </React.Fragment>
  );
};

export default Event;
